<template>
  <EmptyListingBlock
    :title="title"
    :useDefaultImage="true"
    class="empty-reading-now"
  >
    <slot />

    <router-link
      :to="{ name: 'home' }"
      class="btns btns--font-medium empty-reading-now__btn"
      >Go to Discover</router-link
    >
  </EmptyListingBlock>
</template>

<script setup lang="ts">
import EmptyListingBlock from '@/app/components/listing/EmptyListingBlock.vue'

defineProps<{
  title: string
}>()
</script>

<style scoped lang="scss">
.empty-reading-now {
  &__btn {
    @media only screen and (max-width: $w-mobile-s) {
      font-size: 14px;
      line-height: 18px;
    }
  }
}
</style>
